
  import SEO from "../../mixins/SEO";

  export default {
    name: "contentdisplay",
    mixins: [SEO],
    async asyncData({$axios, route, error}) {
      const content = await $axios.get(`api/v1/content/get-news-by-slug?slug=${route.params.id}`);
      if (!content.data) {
          error({ statusCode: 404, message: 'Нет такой статьи, возможно она была перенесена в другую категорию' })
          return null
      }
      return {
        seo: {
          type: 'website',
          title: content.data.title_meta ?? `${content.data.title} - Блог сайта "Онлайн Касса"`,
          description: content.data.description_meta ?? `⭐️ ${content.data.title} ⭐️ Ознакомьтесь с междугородними и международными автобусными маршрутами `
        },
        content: content.data
      }
    }
  }
